export const allPermissionsData = [
  {
    name: "Can Onboard Company",
    slug: "can_onboard_company",
  },
  {
    name: "Can Onboard Users (Staffs) Manually",
    slug: "can_onboard_users_staffs_manually",
  },
  {
    name: "Can Onboard Users with AdSync",
    slug: "can_onboard_users_with_adsync",
  },
  {
    name: "Can Reset Password",
    slug: "can_reset_password",
  },
  {
    name: "Can Login with email & password",
    slug: "can_login_with_email_password",
  },
  {
    name: "Can Login with Microsoft.",
    slug: "can_login_with_microsoft",
  },
  {
    name: "Can View Dashboard",
    slug: "can_view_dashboard",
  },
  {
    name: "Can Apply Filter",
    slug: "can_apply_filter",
  },
  {
    name: "Can Export",
    slug: "can_export",
  },
  {
    name: "Can Create Public Ticket",
    slug: "can_create_public_ticket",
  },
  {
    name: "Can Create Private Ticket",
    slug: "can_create_private_ticket",
  },
  {
    name: "Can Accept Ticket Request",
    slug: "can_accept_ticket_request",
  },
  {
    name: "Can Update Ticket Properties",
    slug: "can_update_ticket_properties",
  },
  {
    name: "Can Close Ticket",
    slug: "can_close_ticket",
  },
  {
    name: "Can Add Comment to Ticket",
    slug: "can_add_comment_to_ticket",
  },
  {
    name: "Can See Ticket Activities",
    slug: "can_see_ticket_activities",
  },
  {
    name: "Can Track Public Tickets",
    slug: "can_track_public_tickets",
  },
  {
    name: "Can be assigned to Tickets",
    slug: "can_be_assigned_to_tickets",
  },
  {
    name: "Admin Settings;",
    slug: "admin_settings",
  },
  {
    name: "Can view Admin Page",
    slug: "can_view_admin_page",
  },
  {
    name: "Can See all Cards",
    slug: "can_see_all_cards",
  },
  {
    name: "Can Update all cards",
    slug: "can_update_all_cards",
  },
  {
    name: "Can see Departments",
    slug: "can_see_departments",
  },
  {
    name: "Can create department",
    slug: "can_create_department",
  },
  {
    name: "Can update department",
    slug: "can_update_department",
  },
  {
    name: "Can add members",
    slug: "can_add_members",
  },
  {
    name: "Can create groups",
    slug: "can_create_groups",
  },
  {
    name: "Can update groups",
    slug: "can_update_groups",
  },
  {
    name: "Can upgrade members",
    slug: "can_upgrade_members",
  },
  {
    name: "Can see Users (Staff)",
    slug: "can_see_users_staff",
  },
  {
    name: "Can create users (Staff)",
    slug: "can_create_users_staff",
  },
  {
    name: "Can update users (Staff)",
    slug: "can_update_users_staff",
  },
  {
    name: "Can upgrade all users",
    slug: "can_upgrade_all_users",
  },
  {
    name: "Can disable users (Staff)",
    slug: "can_disable_users_staff",
  },
  {
    name: "Can see Form Templates",
    slug: "can_see_form_templates",
  },
  {
    name: "Can create form templates",
    slug: "can_create_form_templates",
  },
  {
    name: "Can update form templates",
    slug: "can_update_form_templates",
  },
  {
    name: "Can delete form templates",
    slug: "can_delete_form_templates",
  },
  {
    name: "Can hide form templates",
    slug: "can_hide_form_templates",
  },
  {
    name: "Can copy form template",
    slug: "can_copy_form_template",
  },
  {
    name: "Can see OLA Policies",
    slug: "can_see_ola_policies",
  },
  {
    name: "Can create OLAs",
    slug: "can_create_olas",
  },
  {
    name: "Can Update OLAs",
    slug: "can_update_olas",
  },
  {
    name: "Can see SLA Policies",
    slug: "can_see_sla_policies",
  },
  {
    name: "Can create SLA",
    slug: "can_create_sla",
  },
  {
    name: "Can update SLA",
    slug: "can_update_sla",
  },
  {
    name: "Can see Roles and Permissions",
    slug: "can_see_roles_and_permissions",
  },
  {
    name: "Can create roles.",
    slug: "can_create_roles",
  },
  {
    name: "Can update roles.",
    slug: "can_update_roles",
  },
  {
    name: "Can see notification",
    slug: "can_see_notification",
  },
  {
    name: "Can mark as read",
    slug: "can_mark_as_read",
  },
  {
    name: "Can mark as unread",
    slug: "can_mark_as_unread",
  },
  {
    name: "Can clear notifications",
    slug: "can_clear_notifications",
  },
  {
    name: "Can see basic information",
    slug: "can_see_basic_information",
  },
  {
    name: "Can update phone number & name",
    slug: "can_update_phone_number_name",
  },
  {
    name: "Can Reset password.",
    slug: "can_reset_password",
  },
  {
    name: "Can Reset Password",
    slug: "can_reset_password",
  },
  {
    name: "Can Login with email & password",
    slug: "can_login_with_email_password",
  },
  {
    name: "Can Login with Microsoft.",
    slug: "can_login_with_microsoft",
  },
  {
    name: "Can View Dashboard",
    slug: "can_view_dashboard",
  },
  {
    name: "Can Apply Filter",
    slug: "can_apply_filter",
  },
  {
    name: "Can Export",
    slug: "can_export",
  },
  {
    name: "Can Create Public Ticket",
    slug: "can_create_public_ticket",
  },
  {
    name: "Can Create Private Ticket",
    slug: "can_create_private_ticket",
  },
  {
    name: "Can Accept Ticket Request",
    slug: "can_accept_ticket_request",
  },
  {
    name: "Can Update Ticket Properties",
    slug: "can_update_ticket_properties",
  },
  {
    name: "Can Close Ticket",
    slug: "can_close_ticket",
  },
  {
    name: "Can Add Comment to Ticket",
    slug: "can_add_comment_to_ticket",
  },
  {
    name: "Can See Ticket Activities",
    slug: "can_see_ticket_activities",
  },
  {
    name: "Can Track Public Tickets",
    slug: "can_track_public_tickets",
  },
  {
    name: "Can be assigned to Tickets",
    slug: "can_be_assigned_to_tickets",
  },
  {
    name: "Can view Admin Page",
    slug: "can_view_admin_page",
  },
  {
    name: "Can See all Cards",
    slug: "can_see_all_cards",
  },
  {
    name: "Can see Departments",
    slug: "can_see_departments",
  },
  {
    name: "Can create department",
    slug: "can_create_department",
  },
  {
    name: "Can update department",
    slug: "can_update_department",
  },
  {
    name: "Can add members",
    slug: "can_add_members",
  },
  {
    name: "Can see Users",
    slug: "can_see_users",
  },
  {
    name: "Can see Form Templates",
    slug: "can_see_form_templates",
  },
  {
    name: "Can create form templates",
    slug: "can_create_form_templates",
  },
  {
    name: "Can update form templates",
    slug: "can_update_form_templates",
  },
  {
    name: "Can hide form templates",
    slug: "can_hide_form_templates",
  },
  {
    name: "Can copy form template",
    slug: "can_copy_form_template",
  },
  {
    name: "Can see OLA Policies",
    slug: "can_see_ola_policies",
  },
  {
    name: "Can see SLA Policies",
    slug: "can_see_sla_policies",
  },
  {
    name: "Can create groups",
    slug: "can_create_groups",
  },
  {
    name: "Can update groups",
    slug: "can_update_groups",
  },
  {
    name: "Can upgrade members",
    slug: "can_upgrade_members",
  },
  {
    name: "Can see Users (Staff)",
    slug: "can_see_users_staff",
  },
  {
    name: "Can see Roles and Permissions",
    slug: "can_see_roles_and_permissions",
  },
  {
    name: "Can see notification",
    slug: "can_see_notification",
  },
  {
    name: "Can mark as read",
    slug: "can_mark_as_read",
  },
  {
    name: "Can mark as unread",
    slug: "can_mark_as_unread",
  },
  {
    name: "Can clear notifications",
    slug: "can_clear_notifications",
  },
  {
    name: "Can see basic information",
    slug: "can_see_basic_information",
  },
  {
    name: "Can update phone number & name",
    slug: "can_update_phone_number_name",
  },
  {
    name: "Can create OLAs",
    slug: "can_create_olas",
  },
  {
    name: "Can Update OLAs",
    slug: "can_update_olas",
  },
  {
    name: "Can see SLA Policies",
    slug: "can_see_sla_policies",
  },
  {
    name: "Can create SLA",
    slug: "can_create_sla",
  },
  {
    name: "Can update SLA",
    slug: "can_update_sla",
  },
  {
    name: "Can Reset Password",
    slug: "can_reset_password",
  },
  {
    name: "Can Login with email & password",
    slug: "can_login_with_email_password",
  },
  {
    name: "Can see Form Templates",
    slug: "can_see_form_templates",
  },
  {
    name: "Can Login with Microsoft.",
    slug: "can_login_with_microsoft",
  },
  {
    name: "Can add members",
    slug: "can_add_members",
  },
  {
    name: "Can View Dashboard",
    slug: "can_view_dashboard",
  },
  {
    name: "Can Apply Filter",
    slug: "can_apply_filter",
  },
  {
    name: "Can Export",
    slug: "can_export",
  },
  {
    name: "Can Create Public Ticket",
    slug: "can_create_public_ticket",
  },
  {
    name: "Can Create Private Ticket",
    slug: "can_create_private_ticket",
  },
  {
    name: "Can Accept Ticket Request",
    slug: "can_accept_ticket_request",
  },
  {
    name: "Can Close Ticket",
    slug: "can_close_ticket",
  },
  {
    name: "Can Add Comment to Ticket",
    slug: "can_add_comment_to_ticket",
  },
  {
    name: "Can See Ticket Activities",
    slug: "can_see_ticket_activities",
  },
  {
    name: "Can Track Public Tickets",
    slug: "can_track_public_tickets",
  },
  {
    name: "Can be assigned to Tickets",
    slug: "can_be_assigned_to_tickets",
  },
  {
    name: "Can see Users (Staff)",
    slug: "can_see_users_staff",
  },
  {
    name: "Can see Form Templates",
    slug: "can_see_form_templates",
  },
  {
    name: "Can see OLA Policies",
    slug: "can_see_ola_policies",
  },
  {
    name: "Can see SLA Policies",
    slug: "can_see_sla_policies",
  },
  {
    name: "Can see Roles and Permissions",
    slug: "can_see_roles_and_permissions",
  },
  {
    name: "Can see notification",
    slug: "can_see_notification",
  },
  {
    name: "Can mark as read",
    slug: "can_mark_as_read",
  },
  {
    name: "Can mark as unread",
    slug: "can_mark_as_unread",
  },
  {
    name: "Can clear notifications",
    slug: "can_clear_notifications",
  },
  {
    name: "Can see basic information",
    slug: "can_see_basic_information",
  },
  {
    name: "Can update phone number & name",
    slug: "can_update_phone_number_name",
  },
  {
    name: "Can create OLAs",
    slug: "can_create_olas",
  },
  {
    name: "Can Update OLAs",
    slug: "can_update_olas",
  },
  {
    name: "Can see SLA Policies",
    slug: "can_see_sla_policies",
  },
  {
    name: "Can create SLA",
    slug: "can_create_sla",
  },
  {
    name: "Can update SLA",
    slug: "can_update_sla",
  },
  {
    name: "Can see Departments",
    slug: "can_see_departments",
  },
  {
    name: "Can create department",
    slug: "can_create_department",
  },
  {
    name: "Can update department",
    slug: "can_update_department",
  },
  {
    name: "Can Reset Password",
    slug: "can_reset_password",
  },
  {
    name: "Can Login with email & password",
    slug: "can_login_with_email_password",
  },
  {
    name: "Can Login with Microsoft.",
    slug: "can_login_with_microsoft",
  },
  {
    name: "Can View Dashboard",
    slug: "can_view_dashboard",
  },
  {
    name: "Can Apply Filter",
    slug: "can_apply_filter",
  },
  {
    name: "Can Export",
    slug: "can_export",
  },
  {
    name: "Can Create Public Ticket",
    slug: "can_create_public_ticket",
  },
  {
    name: "Can Create Private Ticket",
    slug: "can_create_private_ticket",
  },
  {
    name: "Can Accept Ticket Request",
    slug: "can_accept_ticket_request",
  },
  {
    name: "Can Close Ticket",
    slug: "can_close_ticket",
  },
  {
    name: "Can Add Comment to Ticket",
    slug: "can_add_comment_to_ticket",
  },
  {
    name: "Can See Ticket Activities",
    slug: "can_see_ticket_activities",
  },
  {
    name: "Can Track Public Tickets",
    slug: "can_track_public_tickets",
  },
  {
    name: "Can be assigned to Tickets",
    slug: "can_be_assigned_to_tickets",
  },
  {
    name: "Can see notification",
    slug: "can_see_notification",
  },
  {
    name: "Can mark as read",
    slug: "can_mark_as_read",
  },
  {
    name: "Can mark as unread",
    slug: "can_mark_as_unread",
  },
  {
    name: "Can clear notifications",
    slug: "can_clear_notifications",
  },
  {
    name: "Can see basic information",
    slug: "can_see_basic_information",
  },
  {
    name: "Can update phone number & name",
    slug: "can_update_phone_number_name",
  },
  {
    name: "Can see Departments",
    slug: "can_see_departments",
  },
];

export const PermissionsEnum = {
  can_onboard_company: "Can Onboard Company",
  can_onboard_users_staffs_manually: "Can Onboard Users (Staffs) Manually",
  can_onboard_users_with_adsync: "Can Onboard Users with AdSync",
  can_reset_password: "Can Reset Password",
  can_login_with_email_password: "Can Login with email & password",
  can_login_with_microsoft: "Can Login with Microsoft.",
  can_view_dashboard: "Can View Dashboard",
  can_apply_filter: "Can Apply Filter",
  can_export: "Can Export",
  can_create_public_ticket: "Can Create Public Ticket",
  can_create_private_ticket: "Can Create Private Ticket",
  can_accept_ticket_request: "Can Accept Ticket Request",
  can_update_ticket_properties: "Can Update Ticket Properties",
  can_close_ticket: "Can Close Ticket",
  can_add_comment_to_ticket: "Can Add Comment to Ticket",
  can_see_ticket_activities: "Can See Ticket Activities",
  can_track_public_tickets: "Can Track Public Tickets",
  can_be_assigned_to_tickets: "Can be assigned to Tickets",
  admin_settings: "Admin Settings;",
  can_view_admin_page: "Can view Admin Page",
  can_see_all_cards: "Can See all Cards",
  can_update_all_cards: "Can Update all cards",
  can_see_departments: "Can see Departments",
  can_create_department: "Can create department",
  can_update_department: "Can update department",
  can_add_members: "Can add members",
  can_create_groups: "Can create groups",
  can_update_groups: "Can update groups",
  can_upgrade_members: "Can upgrade members",
  can_see_users_staff: "Can see Users (Staff)",
  can_create_users_staff: "Can create users (Staff)",
  can_update_users_staff: "Can update users (Staff)",
  can_upgrade_all_users: "Can upgrade all users",
  can_disable_users_staff: "Can disable users (Staff)",
  can_see_form_templates: "Can see Form Templates",
  can_create_form_templates: "Can create form templates",
  can_update_form_templates: "Can update form templates",
  can_delete_form_templates: "Can delete form templates",
  can_hide_form_templates: "Can hide form templates",
  can_copy_form_template: "Can copy form template",
  can_see_ola_policies: "Can see OLA Policies",
  can_create_olas: "Can create OLAs",
  can_update_olas: "Can Update OLAs",
  can_see_sla_policies: "Can see SLA Policies",
  can_create_sla: "Can create SLA",
  can_update_sla: "Can update SLA",
  can_see_roles_and_permissions: "Can see Roles and Permissions",
  can_create_roles: "Can create roles.",
  can_update_roles: "Can update roles.",
  can_see_notification: "Can see notification",
  can_mark_as_read: "Can mark as read",
  can_mark_as_unread: "Can mark as unread",
  can_clear_notifications: "Can clear notifications",
  can_see_basic_information: "Can see basic information",
  can_update_phone_number_name: "Can update phone number & name",
} as const;
